// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventLineItemTradePartnerSelectQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BidContractLineItemFilter>;
}>;


export type ChangeEventLineItemTradePartnerSelectQuery = { __typename?: 'Query', bidContractLineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } }> };

export type ChangeEventLineItemTradePartnerSelect_BidItemBidContractLineItemsFragment = { __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } };

export const ChangeEventLineItemTradePartnerSelect_BidItemBidContractLineItemsFragmentDoc = gql`
    fragment ChangeEventLineItemTradePartnerSelect_BidItemBidContractLineItems on BidContractLineItem {
  id
  totalCostInCents
  revision {
    id
    version
    bidContract {
      id
      tradePartner {
        id
        name
      }
      displayName
    }
  }
  ofIti
}
    `;
export const ChangeEventLineItemTradePartnerSelectDocument = gql`
    query ChangeEventLineItemTradePartnerSelect($filter: BidContractLineItemFilter) {
  bidContractLineItems(filter: $filter) {
    ...ChangeEventLineItemTradePartnerSelect_BidItemBidContractLineItems
  }
}
    ${ChangeEventLineItemTradePartnerSelect_BidItemBidContractLineItemsFragmentDoc}`;

/**
 * __useChangeEventLineItemTradePartnerSelectQuery__
 *
 * To run a query within a React component, call `useChangeEventLineItemTradePartnerSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventLineItemTradePartnerSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventLineItemTradePartnerSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChangeEventLineItemTradePartnerSelectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>(ChangeEventLineItemTradePartnerSelectDocument, options);
      }
export function useChangeEventLineItemTradePartnerSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>(ChangeEventLineItemTradePartnerSelectDocument, options);
        }
// @ts-ignore
export function useChangeEventLineItemTradePartnerSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>;
export function useChangeEventLineItemTradePartnerSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventLineItemTradePartnerSelectQuery | undefined, ChangeEventLineItemTradePartnerSelectQueryVariables>;
export function useChangeEventLineItemTradePartnerSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>(ChangeEventLineItemTradePartnerSelectDocument, options);
        }
export type ChangeEventLineItemTradePartnerSelectQueryHookResult = ReturnType<typeof useChangeEventLineItemTradePartnerSelectQuery>;
export type ChangeEventLineItemTradePartnerSelectLazyQueryHookResult = ReturnType<typeof useChangeEventLineItemTradePartnerSelectLazyQuery>;
export type ChangeEventLineItemTradePartnerSelectSuspenseQueryHookResult = ReturnType<typeof useChangeEventLineItemTradePartnerSelectSuspenseQuery>;
export type ChangeEventLineItemTradePartnerSelectQueryResult = Apollo.QueryResult<ChangeEventLineItemTradePartnerSelectQuery, ChangeEventLineItemTradePartnerSelectQueryVariables>;